import React, { useEffect, useState } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate,
} from "react-router-dom";

import Home from "./Home";
import Contact from "./Contact";
import Programs from "./Programs";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import StudentDashboard from "./pages/StudentDashboard";
import TutorDashboard from "./pages/TutorDashboard";
import OTPLogin from "./components/OTPLogin";
import Services from "./Services";
import About2 from "./About2";
import Error from "./components/Error";

import Nave from "./Nave"; // Navbar
import Footer from "./Footer"; // Footer

// Layout with Header/Footer
const AppLayout = ({ userRole, onLogout }) => {
  return (
    <div>
      <Nave />
      <div style={{ paddingTop: "70px", minHeight: "80vh" }}>
        <Outlet />
      </div>
      <Footer />
      {userRole && (
        <div style={{ textAlign: "center", margin: "20px" }}>
          <button
            onClick={onLogout}
            style={{
              padding: "10px 20px",
              backgroundColor: "#ff4d4d",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

// Main App Component
const App = () => {
  const [userRole, setUserRole] = useState(localStorage.getItem("userRole") || null);

  useEffect(() => {
    const updateRole = () => setUserRole(localStorage.getItem("userRole"));
    window.addEventListener("storage", updateRole);
    return () => window.removeEventListener("storage", updateRole);
  }, []);

  const handleLogin = (role) => {
    localStorage.setItem("userRole", role);
    setUserRole(role);
  };

  const handleLogout = () => {
    localStorage.removeItem("userRole");
    setUserRole(null);
  };

  const router = createBrowserRouter(
    [
      {
        path: "/",
        element: <AppLayout userRole={userRole} onLogout={handleLogout} />,
        errorElement: <Error />,
        children: [
          { path: "/", element: <Home /> },
          { path: "/contact", element: <Contact /> },
          { path: "/programs", element: <Programs /> },
          { path: "/services", element: <Services /> },
          { path: "/about2", element: <About2 /> },
          { path: "/login", element: <Login onLogin={handleLogin} /> },
          { path: "/signup", element: <Signup /> },
          { path: "/otp-login", element: <OTPLogin /> },
          {
            path: "/student-dashboard",
            element:
              userRole === "student" ? <StudentDashboard /> : <Navigate to="/login" />,
          },
          {
            path: "/tutor-dashboard",
            element:
              userRole === "tutor" ? <TutorDashboard /> : <Navigate to="/login" />,
          },
          {
            path: "*",
            element: <Navigate to="/" />,
          },
        ],
      },
    ],
    {
      future: {
        v7_startTransition: true,
      },
    }
  );

  return <RouterProvider router={router} />;
};

export default App;
